module.exports = __webpack_public_path__ + "static/img/logo-GOLD-COAST.876e8cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-GOLD-COAST.svg
// module id = J2sO
// module chunks = 1